/**
 * TKP-143 / tasarım s.33 md.2a-b (karar 2026-09-27): çalışma alanı panelinin ana ekranı liste; alt ekranlar seçili çalışma
 * alanı bağlamı ister (kapı `isWorkspaceSelected`, `router/routes.js`). Saf yardımcı — kapı kuralı DB'siz test edilir.
 */

/** Ana ekran (`/`), eski liste yönlendirmesi (`workspaces`) ve `/workspace` — seçili çalışma alanı gerektirmez. */
export const isWorkspaceListPath = (path) => ["/", "/workspace", "workspaces", "/workspace/workspaces"].includes(path);
